import { Conference, Excursion } from '@ag-common-lib/public-api';

export enum ExcursionModalAction {
  create = 'create',
  copy = 'copy',
  edit = 'edit',
  view = 'view',
}

export class ExcursionModalPayload {
  action: ExcursionModalAction;
  conference: Conference;
  path: string;
  excursion?: Excursion;
}
